import { create } from 'zustand';
import { getPage } from '@/services/global/admin.service';
import { AdminOnboarding } from '@/graphql/generated/graphql';

type AdminStore = {
  loading: boolean;
  page: AdminOnboarding | null;
  onInit: () => Promise<void>;
};

export const useAdminStore = create<AdminStore>()((set) => ({
  loading: true,
  page: null,
  onInit: async () => {
    set({ loading: true });
    const { page, error } = await getPage();

    if (error) {
      throw new Error('Failed to fetch page');
    }

    set({
      page,
      loading: false,
    });
  },
}));
